<template>
  <div class="prologue container background-color-green">
    <video
      v-show="videoStarted"
      muted
      playsinline
      loop
      ref="introVideo"
      :class="['intro-video', { started: prologueStep === 'intro' }]"
    >
      <source src="@/assets/videos/intro.mp4" type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>

    <div class="steps-wrapper">
      <img
        class="start-image"
        src="@/assets/images/peopleFrame.png"
        v-show="!videoStarted"
      />

      <div v-if="prologueStep === 'start'" class="h-full overlay">
        <Start @setPrologueStep="setPrologueStep" />
      </div>

      <div v-if="prologueStep === 'intro'" class="h-full overlay">
        <Intro />
      </div>
    </div>

    <!-- <img class="fog" src="@/assets/images/fog.png" /> -->
  </div>
</template>

<script>
import Start from "@/components/prologue/Start";
import Intro from "@/components/prologue/Intro";
export default {
  components: { Start, Intro },
  data() {
    return {
      prologueStep: "start",
      videoStarted: false,
    };
  },
  methods: {
    setPrologueStep(step) {
      // start the video
      if (step === "intro") {
        this.videoStarted = true;
        const video = this.$refs.introVideo;
        video.play();
      }
      this.prologueStep = step;
    },
  },
};
</script>

<style lang="sass" scoped>
.background-color-green
  background-color: #0C412F
  padding: 2rem
  padding-top: 5rem
  display: flex
  flex-direction: column
  align-items: center
  width: 100%

.steps-wrapper
  display: flex
  flex-direction: column
  align-items: center
  position: relative
  width: 100%
  height: 100%
  border-radius: 4rem
  overflow: hidden

.overlay
  position: absolute
  inset: 0
  width: 100%
  height: 100%

.start-image
  z-index: 1
  width: 100%
  height: 100%
  -webkit-transform-style: preserve-3d
  will-change: transform
  aspect-ratio: 9 / 16
  object-fit: cover

  &.started
    animation: 1s ease-out 0s slideVideo forwards

.intro-video, .intro-image
  z-index: 1
  position: absolute
  top: 0
  height: 100%
  -webkit-transform-style: preserve-3d
  will-change: transform
  transform-origin: left
  left: 0

  &.started
    animation: 1s ease-out 0s slideVideo forwards

.fog
  transform: translateX(-200rem)
  z-index: 200
  position: absolute
  bottom: -10rem
  animation: slideFog 50s 1s linear infinite
  will-change: transform
  left: 0
  transform: translateX(-100%)

@keyframes slideFog
  to
    transform: translateX(100%)

@keyframes slideVideo
  from
    transform: translateX(50%)
  to
    transform: translateX(0%)
</style>
